<template>
  <div class="forget-container">
    <div class="form-container">
      <div class="form-link">已有账户，<router-link to="/login">马上登录</router-link></div>
      <div class="form-head">账号安全</div>
      <div class="form-main">
        <div class="form-main_">
          <div class="stepone" v-if="stepOne">
            <div class="form-main-head">找回密码</div>
            <div class="login-inputbox">
              <div class="inputbox account">
                <input type="text" maxlength="11" v-model="formdata.mobile" id="mobile" class="input" placeholder="请输入手机号">
              </div>
            </div>
            <div class="login-inputbox">
              <div class="">
                <div id="embed-captcha"></div>
                <p id="wait" class="show">正在加载验证码......</p>
                <p id="notice" class="hide">请先完成验证</p>
              </div>
            </div>
            <div class="login-inputbox">
              <div class="inputbox verification">
                <input type="text" v-model="formdata.verification" id="verification" class="input" placeholder="请输入短信验证码">
              </div>
              <div class="verification-btn" @click="getVerification" v-if="time===0">发送验证码</div>
              <div class="verification-btn" @click="getVerification" v-else>{{time}}s后重新发送</div>
            </div>
            <div class="login-submit" @click="stepOneDo">下一步</div>
          </div>
          <div class="steptwo" v-else>
            <div class="form-main-head">重置密码</div>
            <div class="login-inputbox">
              <div class="inputbox password">
                <input type="password" v-model="password" id="password" class="input" placeholder="设置6至20登录密码">
              </div>
            </div>
            <div class="login-inputbox">
              <div class="inputbox password">
                <input type="password" v-model="repassword" id="repassword" class="input password" placeholder="请输入登录密码">
              </div>
            </div>
            <div class="login-submit" @click="stepTwoDo">完成</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setToken } from '../../utils/auth'
import store from '../../store/index'
import { baseUrl } from '../../config/env'
import { getHeaderData } from '../../api/getData'
import { getForgetCode, getForgetStepOne, getForgetStepTwo } from '../../api/login'
import { validateMobile, validatePassword } from '../../assets/js/validate.js'
export default {
  name: 'forget',
  data () {
    return {
      headerInfo: {},
      formdata: {
        mobile: '',
        verification: ''
      },
      id: '',
      password: '',
      repassword: '',
      stepOne: true,
      captchaObj: {},
      time: 0
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  created () {
    this.getHeaderInfo()
    this.getSlideCodeMobile()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
    },
    async stepOneDo () {
      let captchaObj = this.captchaObj
      if (this.verification()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice')[0].className = 'show'
          setTimeout(function () {
            $('#notice')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          if (this.formdata.verification === '') {
            this.message('请输入验证码')
            return false
          }
          let postData = {}
          postData.mobile = this.formdata.mobile.trim()
          postData.vercode = this.formdata.verification
          let result = await getForgetStepOne(postData)
          if (result.code === '1') {
            this.id = result.id
            this.stepOne = false
          } else {
            this.message(result.msg)
          }
        }
      }
    },
    async stepTwoDo () {
      if (this.password === '') {
        this.message('请输入登录密码')
        return false
      }
      if (!validatePassword(this.password)) {
        this.message('密码长度6~20位，且同时包含数字、字母')
        return false
      }
      if (this.repassword === '') {
        this.message('请再次输入登录密码')
        return false
      }
      if (this.repassword !== this.password) {
        this.message('两次密码输入不一致')
        return false
      }
      let postData = {}
      postData.id = this.id
      postData.password = this.encrypt(this.password)
      let result = await getForgetStepTwo(postData)
      if (result.code === '1') {
        store.commit('SET_USERID', result.userinfo.user_id)
        store.commit('SET_USER', result.userinfo.username)
        setToken('userId', result.userinfo.user_id)
        setToken('username', result.userinfo.username)
        this.$router.push({ path: '/success/index2' })
      } else {
        this.message(result.msg)
      }
    },
    async getVerification () {
      let self = this
      if (this.time !== 0) {
        return false
      }
      let captchaObj = this.captchaObj
      if (this.verification()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice')[0].className = 'show'
          setTimeout(function () {
            $('#notice')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          let postData = {}
          postData.mobile = this.formdata.mobile
          postData.geetest_challenge = $('input[name="geetest_challenge"]').val()
          postData.geetest_validate = $('input[name="geetest_validate"]').val()
          postData.geetest_seccode = $('input[name="geetest_seccode"]').val()
          let result = await getForgetCode(postData)
          if (result.code === '1') {
            this.time = 60
            let t = setInterval(function () {
              self.time = self.time - 1
            }, 1000)
            setTimeout(function () {
              clearInterval(t)
            }, 60000)
            this.message('验证码发送成功')
          } else {
            this.message('验证码发送失败')
          }
        }
      }
    },
    verification () {
      if (this.formdata.mobile === '') {
        this.message('请输入手机号')
        return false
      }
      if (!validateMobile(this.formdata.mobile)) {
        this.message('手机号格式不正确')
        return false
      }
      return true
    },
    encrypt (pwd) {
      let pubkey = '-----BEGIN PUBLIC KEY-----'
      pubkey += 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqtcivu827OwO3XQZPpjI'
      pubkey += 'xv3sf3ar0wYkjk6k2XeYJVhyUmqR8r5tpsiLsUhsXwAEA0hjPLkVGHx6ms9A9Tbd'
      pubkey += 'PAji3/WygeCb3SwB3dK85thQlNfGmOS/dtxaUguWU1bZDHN0xldJEVzQFdzpRtce'
      pubkey += 'rTRLyZnYc/SVhUdlhORKDgfu7+ZsH2Xwi8gO3LdqABeukeqqOqnmEtxRIzVWNJsV'
      pubkey += '6TR+2exwxlS5D6B7jEOmBUCvGsNi7xBaQYgXg8aH87CP4pNdueBvCDAIB5oB6zVg'
      pubkey += 'mrVxG909H8pKMZp+4A0AmjXOgTzEhnZ5dB2WHUZT1XvC8CugW/T5U2AX9x0am1+5'
      pubkey += 'aQIDAQAB'
      pubkey += '-----END PUBLIC KEY-----'
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(pubkey)
      let encrypted = encrypt.encrypt(JSON.stringify({ 'encrypt': 'yes', 'password': pwd }))
      return encrypted
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    },
    handlerEmbedMobile (captchaObj) {
      this.captchaObj = captchaObj
      // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
      $('#embed-captcha').html('')
      captchaObj.appendTo('#embed-captcha')
      captchaObj.onReady(function () {
        $('#wait')[0].className = 'hide'
      })
    },
    getSlideCodeMobile () {
      let self = this
      $.ajax({
        // 获取id，challenge，success（是否启用failback）
        url: baseUrl + '/Verify/Start?t=' + (new Date()).getTime(), // 加随机数防止缓存
        type: 'get',
        dataType: 'json',
        success: function (data) {
          // 使用initGeetest接口
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它做appendTo之类的事件
          initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            new_captcha: data.new_captcha,
            product: 'embed', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
            offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
          }, self.handlerEmbedMobile)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .forget-container{
    padding: 90px 0 170px;
    background-image: url("../../assets/images/login-bg.jpg");
    background-repeat: no-repeat;
    background-position: center top;
  }
  .form-container{
    position: relative;
    width: 1300px;
    margin: 0 auto;
    .form-link{
      position: absolute;
      right: 0;
      top: -48px;
      font-size: 20px;
      line-height: 48px;
      color: #333333;
      a{
        color: #4b7bbe;
      }
    }
    .form-head{
      width: 100%;
      height: 90px;
      background-color: #ec6420;
      font-size: 30px;
      line-height: 90px;
      text-align: center;
      color: #ffffff;
    }
    .form-main{
      height: 610px;
      background-color: #ffffff;
      .form-main_{
        width: 490px;
        margin: 0 auto;
        padding: 80px 0 0;
        .form-main-head{
          padding: 0 0 39px;
          font-size: 24px;
          line-height: 24px;
          text-align: center;
          color: #333333;
        }
        .login-inputbox{
          width: 100%;
          height: 50px;
          border-radius: 25px;
          margin-bottom: 30px;
          .inputbox{
            width: 100%;
            height: 100%;
            padding-left: 65px;
            border-radius: 25px;
            box-shadow: 0px 0px 7.47px 1.53px rgba(4, 0, 0, 0.15);
            background-image: url("../../assets/images/icons.png");
            background-repeat: no-repeat;
            &.account{
              background-position: -326px -138px;
            }
            &.password{
              background-position: -321px -197px;
            }
            &.verification{
              float: left;
              width: 71.42%;
              background-position: -326px -82px;
            }
            .input{
              width: 100%;
              height: 100%;
              padding-right: 30px;
              border-bottom-right-radius: 25px;
              border-top-right-radius: 25px;
              font-size: 18px;
              line-height: 50px;
              color: #999999;
            }
          }
          .verification-btn{
            float: right;
            width: 26.53%;
            height: 100%;
            border-radius: 25px;
            box-shadow: 0px 0px 7.47px 1.53px rgba(4, 0, 0, 0.15);
            font-size: 18px;
            line-height: 50px;
            text-align: center;
            color: #008489;
            cursor: pointer;
          }
        }
        .login-submit{
          width: 100%;
          height: 50px;
          border-radius: 25px;
          background-color: #ec6420;
          box-shadow: 0px 0px 7.47px 1.53px rgba(4, 0, 0, 0.15);
          margin-top: 60px;
          font-size: 24px;
          line-height: 50px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
          transition: all 0.5s ease 0s;
          &:hover{
            background-color: #e5540c;
          }
        }
      }
    }
  }
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  #notice {
    color: red;
  }
  @media screen and (max-width: 1320px){
    .form-container{
      width: 100%;
      padding: 0 10px;
      .form-link{
        right: 10px;
      }
    }
  }
  @media screen and (max-width: 1200px){
    .forget-container{
      padding: 50px 10px 25px;
    }
    .form-container{
      padding: 0;
      .form-link{
        right: 0;
        top: -50px;
        font-size: 12px;
        line-height: 50px;
      }
      .form-head{
        height: 50px;
        font-size: 16px;
        line-height: 50px;
      }
      .form-main{
        height: 100%;
        background-color: #ffffff;
        .form-main_{
          width: 100%;
          padding: 43px 15px 58px;
          .form-main-head{
            padding: 0 0 22px;
            font-size: 14px;
            line-height: 18px;
          }
          .login-inputbox{
            height: 30px;
            border-radius: 15px;
            margin-bottom: 15px;
            .inputbox{
              padding-left: 30px;
              border-radius: 15px;
              background-size: 230px auto;
              &.account{
                background-position: -163px -67px;
              }
              &.password{
                background-position: -160px -96px;
              }
              &.verification{
                float: left;
                width: 71.42%;
                background-position: -163px -39px;
              }
              .input{
                padding-right: 15px;
                border-bottom-right-radius: 15px;
                border-top-right-radius: 15px;
                font-size: 12px;
                line-height: 30px;
              }
            }
            .verification-btn{
              border-radius: 15px;
              font-size: 12px;
              line-height: 30px;
            }
          }
          .login-submit{
            height: 30px;
            border-radius: 15px;
            margin-top: 32px;
            font-size: 14px;
            line-height: 30px;
          }
        }
      }
    }
  }
</style>
